import { render, staticRenderFns } from "./EventsListPage.vue?vue&type=template&id=0a26409e&"
import script from "./EventsListPage.vue?vue&type=script&lang=ts&"
export * from "./EventsListPage.vue?vue&type=script&lang=ts&"
import style0 from "./EventsListPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/BUILD/Desktop/vsts-agent-win-x64-2.131.0/_work/13/s/DiapasonWeb/Client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {VAvatar,VBtn,VCard,VIcon,VImg,VMenu})
